<template>
  <Minimal>
    <div class="h-screen bg-gray-50 flex overflow-hidden">
      <!-- 最左侧导航栏 -->
      <nav class="w-14 bg-gray-800 flex flex-col h-screen">
        <!-- 顶部用户头像 -->
        <div class="p-2 border-b border-gray-700">
          <slot name="nav-user-avatar">
            <div class="w-10 h-10 rounded bg-blue-500 flex items-center justify-center text-white font-semibold">
              D
            </div>
          </slot>
        </div>

        <!-- 导航菜单 -->
        <div class="flex-1 py-3">
          <div class="space-y-2">
            <!-- 聊天 -->
            <div class="nav-item active" @click="$emit('nav-change', 'chat')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
            </div>

            <!-- 通讯录 -->
            <div class="nav-item" @click="$emit('nav-change', 'contacts')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>

            <!-- 工作台 -->
            <div class="nav-item" @click="$emit('nav-change', 'workbench')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>

            <!-- 应用 -->
            <div class="nav-item" @click="$emit('nav-change', 'apps')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
              </svg>
            </div>

            <!-- 日历 -->
            <div class="nav-item" @click="$emit('nav-change', 'calendar')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>

            <!-- 文档 -->
            <div class="nav-item" @click="$emit('nav-change', 'docs')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>

            <!-- 邮件 -->
            <div class="nav-item" @click="$emit('nav-change', 'mail')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>

            <!-- 会议 -->
            <div class="nav-item" @click="$emit('nav-change', 'meeting')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        </div>

        <!-- 底部设置 -->
        <div class="border-t border-gray-700 p-2">
          <div class="nav-item" @click="$emit('nav-change', 'settings')">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        </div>
      </nav>

      <!-- 左侧边栏: 联系人列表 -->
      <aside class="w-64 bg-white border-r border-gray-200 flex flex-col h-screen">
        <!-- 顶部标题 -->
        <div class="h-12 px-4 border-b border-gray-100 flex items-center justify-between bg-white">
          <div class="flex items-center">
            <!-- 使用 SVG 代替图片文件 -->
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            <slot name="app-title" />
            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 ml-1 text-gray-400" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div class="flex items-center space-x-2 text-gray-400">
            <button class="hover:text-gray-600 p-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>
            <button class="hover:text-gray-600 p-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="p-2">
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input type="text"
              class="pl-7 pr-3 py-1.5 w-full bg-gray-100 border-0 rounded text-xs placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-green-400"
              :placeholder="$t('chat.layout.search')" />
          </div>
        </div>

        <!-- Tab 切换 -->
        <div class="px-2 border-b border-gray-100">
          <slot name="chat-tabs" />
        </div>

        <!-- 联系人列表容器 -->
        <div class="overflow-y-auto flex-1">
          <slot name="contacts-list" />
        </div>
      </aside>

      <!-- 主聊天区域 -->
      <main class="flex-1 flex flex-col h-screen overflow-hidden">
        <!-- 聊天头部 -->
        <header class="bg-white h-12 border-b border-gray-200 flex items-center px-4">
          <div class="flex items-center">
            <div class="mr-3">
              <slot name="chat-avatar" />
            </div>
            <div>
              <div class="font-medium text-sm">
                <slot name="chat-title" />
              </div>
              <div class="text-xs text-gray-500">
                <slot name="chat-subtitle" />
              </div>
            </div>
          </div>
        </header>

        <!-- 聊天内容 -->
        <div class="flex-1 overflow-y-auto p-3 bg-gray-50"
          style="background: linear-gradient(180deg, #ededed 0%, #e8e8e8 100%);">
          <slot name="messages" />
        </div>

        <!-- 输入框区域 -->
        <div class="bg-white p-3 border-t border-gray-200">
          <slot name="message-input" />
        </div>
      </main>

      <!-- 右侧边栏：用户信息和素材库 -->
      <aside class="w-72 bg-white border-l border-gray-200 flex flex-col h-screen">
        <!-- 用户信息区域 -->
        <div class="h-12 px-4 border-b border-gray-100 flex items-center justify-between bg-white">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2 text-blue-500" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <h2 class="text-sm font-medium">{{ $t('chat.layout.user.info') }}</h2>
          </div>
          <button class="text-gray-400 hover:text-gray-600 p-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
            </svg>
          </button>
        </div>

        <!-- 用户信息内容 -->
        <div class="p-3 border-b">
          <slot name="user-info">
            <!-- 默认用户信息卡片 -->
            <div class="bg-gray-50 rounded p-3">
              <div class="flex items-center mb-2">
                <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <h3 class="text-sm font-medium">{{ $t('common.username') || '用户名' }}</h3>
                  <p class="text-xs text-gray-500">{{ $t('chat.layout.user.online') }}</p>
                </div>
              </div>
              <div class="text-xs text-gray-600 space-y-1">
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1 text-gray-400" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>{{ $t('chat.layout.user.email') || 'user@example.com' }}</span>
                </div>
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1 text-gray-400" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{{ $t('chat.layout.user.lastLogin') }}：今天 15:30</span>
                </div>
              </div>
            </div>
          </slot>
        </div>

        <!-- 快捷操作区域 -->
        <div class="p-3 border-b">
          <div class="grid grid-cols-3 gap-2">
            <button class="flex flex-col items-center p-2 rounded hover:bg-gray-50">
              <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                </svg>
              </div>
              <span class="text-xs text-gray-600">企业资料</span>
            </button>
            <button class="flex flex-col items-center p-2 rounded hover:bg-gray-50">
              <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-green-500" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <span class="text-xs text-gray-600">小助手</span>
            </button>
            <button class="flex flex-col items-center p-2 rounded hover:bg-gray-50">
              <div class="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-purple-500" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <span class="text-xs text-gray-600">个人资料</span>
            </button>
          </div>
        </div>

        <!-- 素材库区域 -->
        <div class="h-12 px-4 border-b flex items-center justify-between bg-gray-50">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2 text-blue-500" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <h2 class="text-sm font-medium">{{ $t('chat.layout.material.library') }}</h2>
          </div>
          <div class="flex items-center space-x-1">
            <button class="text-gray-400 hover:text-blue-500 p-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
            </button>
            <button class="text-gray-400 hover:text-blue-500 p-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </button>
          </div>
        </div>

        <!-- 素材库内容 -->
        <div class="overflow-y-auto p-2 flex-1">
          <slot name="material-library">
            <!-- 默认素材内容 -->
            <div class="grid grid-cols-2 gap-2">
              <!-- 图片素材示例 -->
              <div class="bg-gray-50 rounded p-2 hover:bg-gray-100 cursor-pointer">
                <div class="h-16 rounded bg-blue-100 mb-1 flex items-center justify-center text-blue-300">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <p class="text-xs truncate">{{ $t('chat.layout.material.image.title') }}</p>
              </div>

              <!-- 文档素材示例 -->
              <div class="bg-gray-50 rounded p-2 hover:bg-gray-100 cursor-pointer">
                <div class="h-16 rounded bg-green-100 mb-1 flex items-center justify-center text-green-300">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p class="text-xs truncate">{{ $t('chat.layout.material.document.title') }}</p>
              </div>

              <!-- 视频素材示例 -->
              <div class="bg-gray-50 rounded p-2 hover:bg-gray-100 cursor-pointer">
                <div class="h-16 rounded bg-red-100 mb-1 flex items-center justify-center text-red-300">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
                <p class="text-xs truncate">{{ $t('chat.layout.material.video.title') }}</p>
              </div>

              <!-- 音频素材示例 -->
              <div class="bg-gray-50 rounded p-2 hover:bg-gray-100 cursor-pointer">
                <div class="h-16 rounded bg-purple-100 mb-1 flex items-center justify-center text-purple-300">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                  </svg>
                </div>
                <p class="text-xs truncate">{{ $t('chat.layout.material.audio.title') }}</p>
              </div>
            </div>
          </slot>
        </div>
      </aside>
    </div>
  </Minimal>
</template>

<script setup>
import Minimal from '@/layouts/Minimal.vue'
import { useChat } from '@/hooks/useChat'

// 定义 emits
defineEmits(['nav-change'])

// 定义插槽
defineSlots()

// 侧边栏状态
const sidebarCollapsed = ref(false)

// 切换侧边栏
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

// ActionCable连接管理
const {
  isConnected,
  connect,
  disconnect
} = useChat(1) // 假设当前用户ID为1

// 生命周期管理
onMounted(() => {
  // 在布局层面建立ActionCable连接
  connect()
})

onUnmounted(() => {
  // 断开连接
  disconnect()
})
</script>

<style scoped>
@reference "../entrypoints/application.css";

/* 导航项样式 */
.nav-item {
  @apply w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700 cursor-pointer transition-all duration-200 mx-auto;
}

.nav-item.active {
  @apply bg-blue-600 text-white;
}

.nav-item:hover {
  @apply transform scale-105;
}
</style>
